<template>
  <p class="description">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'Description'
}
</script>

<style scoped lang="scss">
.description {
  font-size: 16px;
  font-weight: 400;
  line-height: 18.38px;
  margin-bottom: 30px;
  text-align: center;
}
</style>
